import React from 'react';
import './About.css';
import reactImage from '../../../images/react-2.svg';
import aboutSVG from '../../../images/about-avatar.svg';
import curveLine from '../../../images/curve.svg';

const About = () => {

    return (
        <>
            <section id="about">
                <div className="service__avatar">
                    <img src={curveLine} alt="curve line" />
                </div>
                <div className="container">
                    <div className="section__header">
                        <h2 className="section__title">
                            I'm a Front-End Developer
                            <br />
                            working from home
                        </h2>
                        <p className="section__subtitle">
                        Experienced MERN stack developer adapt in all stages of advanced web development. Proficient in an assortment of technologies, including 
                        <span className="tooltipImage"> JavaScript <img src={reactImage} alt="" /> </span> 
                        CSS, 
                        JavaScript, 
                        React.js, 
                        Node.js, 
                        Express.js, 
                        and MongoDB.
                        <br /><br />
                        1+ years experienced React Developer with implementing highly-responsive user interface components by deploying React concept. Also knowledgeable in WordPress theme development.
                        </p>
                    </div>

                    <div className="cv__btn--wrapper mt-5">
                        <button className="btn__brand">Download CV &rarr;</button>
                    </div>
                </div>


                <div className="about__avatar">
                    <img src={aboutSVG} alt="" />
                </div>
            </section>
        </>
    );
};

export default About;